// Dashboard ke agent cards ka shimmer — utne hi cards, usi size ke.
//
// Do jagah lagta hai:
//   • /dashboard ke SecureRoute ka fallback (token verify hone tak) — teen-dot
//     wale poore-page loader ki jagah.
//   • Dashboard ke andar, jab agents pehli baar aa rahe hon (`bare`: sirf
//     cards, kyunki wahan .main wrapper pehle se hai).
//
// Cards ki ginti store me rakhe pichhle agents se aati hai, taaki asli cards
// aane par layout uchhle nahi.
import React from "react";
import { useDashboardStore } from "../../../Store/agentZustandStore";
import dashStyles from "../Dashboard.module.css";
import styles from "./DashboardSkeleton.module.css";

const DEFAULT_CARDS = 2;

const DashboardSkeleton = ({ bare = false }) => {
  const cached = useDashboardStore((s) => s.agents?.length || 0);
  const cards = Array.from({ length: cached || DEFAULT_CARDS }, (_, i) => (
    // .LangStyle = asli card ka size (mobile poori chaudai, desktop 30% / 400px).
    <div key={i} className={`${dashStyles.LangStyle} ${styles.card}`} aria-hidden="true" />
  ));

  if (bare) return <>{cards}</>;

  return (
    <div className={`${dashStyles.main} ${styles.page}`} aria-busy="true" aria-label="Loading agents">
      {cards}
    </div>
  );
};

export default DashboardSkeleton;
